import { DateTime } from 'luxon';

export function isDateTimeSunday(dateTime: DateTime): boolean {
  return dateTime.weekday === 7;
}
